var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.release.id)?_c('div',[_c('h3',{staticClass:"h3"},[_vm._v("Version "+_vm._s(_vm.release.version))]),_c('h4',{staticClass:"text-subtitle-1"},[_vm._v(_vm._s(_vm.releasedAt))]),_c('p',{staticClass:"my-5",domProps:{"innerHTML":_vm._s(_vm.release.summary)}}),_c('v-btn',{staticClass:"my-5",attrs:{"outlined":"","color":"primary","loading":_vm.working,"to":{
      name: 'currentRelease/feedback',
      params: { releaseId: _vm.release.id },
    }}},[_vm._v("Send feedback")])],1):_c('div',[_c('p',[_vm._v(_vm._s(_vm.i18n("indeterminate")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }